(function() {
'use strict';

angular
    .module('TR')
    .controller('HolidaySearch', HolidaySearch);

function HolidaySearch(
    broker,
    $route,
    $scope,
    $window,
    flightSearch,
    $routeParams,
    searchUnitService,
    resourceService,
    basketService,
    basketStore,
    bd4travel,
    $timeout,
    tripService,
    loggingService,
    dateUtil,
    occupancyService,
    locationService,
    flightsFilterService,
    analytics,
    $compile,
    confirmPopupService,
    $filter) {
    const cm = this;
    const { tripId } = $routeParams;
    const rangeFilters = ['PriceRange', 'OutboundTakeOffRange', 'ReturnTakeOffRange'];

    let searching = true;
    let routeSummaryUpToDate = false;

    let queryParams = {};
    cm.startAgainHolidayUrl = 'holidays';
     $scope.$on('$routeChangeSuccess', function(prev, next, current = {}) {
        const { params } = current;
        queryParams = { ...params };
        const { fid } = queryParams;
        cm.startAgainHolidayUrl = (fid) ? `holidays?fid=${fid}` : 'holidays';
    });

    cm.basePrice = 0;
    cm.bags = 0;
    cm.filter = flightSearch.getFilter();
    cm.setTab = setTab;
    cm.filterTab = filterTab;
    cm.listTab = listTab;
    cm.more = more;
    cm.selectFlight = selectFlight;
    cm.showSpinner = showSpinner;
    cm.sortTab = sortTab;
    cm.tab = 'list';
    cm.translateStop = translateStop;
    updateOccupancy();
    cm.isPackagePrice = TRPCONFIG.Domain.PackagePrice && _.get($route, 'current.area') === 'holidays';
    cm.staticFlightsHero = _.get($route, 'current.area') === 'flights';
    cm.filterAllButtonEnabled = TRPCONFIG.Domain.FilterAllButtonEnabled;
    cm.showDetails = showDetails;
    cm.priceExcludesTax = TRPCONFIG.Domain.PriceExcludesTax;



    // Desktop
    // for responsive filter panel
    cm.openSlideFilter = openSlideFilter;
    cm.showSlideFilter = false;

    cm.showSearchUnit = TRPCONFIG.Domain.SearchUnitExpanded && TRPCONFIG.DeviceCategory !== 'Phone';
    cm.toggleSearchUnit = toggleSearchUnit;
    cm.updating = false;
    cm.isHotelFirstJourney = basketService.isFlightPreselected();
    cm.showSelectedFlightV2 = TRPCONFIG.Domain2.ShowSelectedFlightV2;
    // DesktopEnd

    cm.showFilterOption = function(aggregate) {
        return !aggregate || Object.keys(aggregate).length > 0;
    };

    scrollTo(0, 0);
    _block();

    broker.subscribe('HolidaySearchCtrl', 'flightResultsModified', function(ev) {
        _modifyResults(ev.data);
    });

    broker.subscribe('HolidaySearchCtrl', 'newSearchTriggered', function() {
        cm.bags = 0;
        cm.currentFlight = null;
        cm.currentFlightRequestedDates = null;
        routeSummaryUpToDate = false;
    });

    broker.subscribe('HolidaySearchCtrl', 'searchCriteriaModified', function() {
        cm.updating = true;
    });

    broker.subscribe('HolidaySearchCtrl', 'flightNotAvailable', () => cm.flightUnavailable = true);
    //nothing can happen unless we can decipher the tripId
    tripService.getTrip(tripId)
        .then(trip => {
            const { FlightsRequest = {} } = trip || {};
            const selectedFlightExists = FlightsRequest && FlightsRequest.SelectedFlight;
            cm.selectedFlightAvailable = selectedFlightExists && selectedFlightExists.FlightId;

            function loggingError(message) {
                loggingService.logError(`HolidaySearch: tripId:${tripId} returned a ${message}`);
                _unblock();
                locationService.home();
            }

            if (trip == null) {
                return loggingError('null trip');
            }

            if (trip.FlightsRequest == null) {
                return loggingError(`trip with a null FlightsRequest: ${JSON.stringify(trip)}`);
            }

            const { FlexibleTripType, TripType } = trip;
            const isHolidayAreaInner = _.get($route, 'current.area') === 'holidays';
            const isHolidayType = TripType === tripService.tripTypes.Holiday;
            const departureDate = trip.FlightsRequest.DepartureDate;
            const returnDate = trip.FlightsRequest.ReturnDate;
            const searchId = trip.FlightsRequest.AvailabilitySearchId;
            const basketId = trip.BasketId;

            cm.tripType = TripType;
            cm.showAtolProtection = isHolidayType && isHolidayAreaInner && !FlexibleTripType;
            cm.sortCriteria = flightSearch.getSortCriteria(trip.FlightsRequest.OneWayOnly);
            cm.oneWayOnly = trip.FlightsRequest.OneWayOnly;

            if (trip.FlightsRequest.SelectedFlight) {
                cm.bags = trip.FlightsRequest.SelectedFlight.BaggageCount;
                cm.flightUnavailable = trip.FlightsRequest.SelectedFlight.Unavailable;
            }

            cm.next = function() {
                cm.busy = true;
                flightSearch.nextPage()
                    .then(_setResults);
            };

            cm.applyFilters = flightSearch.filter;

            cm.applySort = function() {
                flightSearch.sort(cm.req.SortCriterion);
            };

            cm.removeArrayFilter = function(filter, ap) {
                flightSearch.removeArrayFilter(filter, ap);
            };

            cm.resetBooleanFilter = function(filter) {
                flightSearch.resetBooleanFilter(filter);
            };

            cm.resetRangeFilter = function(filter, minmax) {
                flightSearch.resetRangeFilter(filter, minmax);
            };

            cm.resetFilters = function() {
                flightSearch.resetFilters();
            };

            tripService.usePackageRates().then(packagePrice => {
                cm.isPackagePrice = packagePrice || cm.isHotelFirstJourney;
                cm.bestFlight = TRPCONFIG.Domain.BestFitFlightSelection || packagePrice;
                if (cm.bestFlight) {
                    _unblock();
                    if (trip.FlightsRequest.SelectedFlight) {
                        cm.basePrice = trip.FlightsRequest.SelectedFlight.LeadAdultPrice + trip.FlightsRequest.SelectedFlight.LeadAdultTax;
                        cm.basePriceReady = true;
                    }
                }
            });

            basketService.getFlight(basketId)
                .then(flight => {
                    if (flight && trip.FlightsRequest.SelectedFlight) {
                        let numBags = cm.bags;

                        flight.Details.Itinerary.FlightId = trip.FlightsRequest.SelectedFlight.FlightId;
                        flight.Details.Itinerary.LeadAdultPrice = trip.FlightsRequest.SelectedFlight.LeadAdultPrice;
                        flight.Details.Itinerary.LeadAdultTax = trip.FlightsRequest.SelectedFlight.LeadAdultTax;
                        flight.Details.Itinerary.LeadBaggagePrice = trip.FlightsRequest.SelectedFlight.LeadBaggagePrice;
                        flight.Details.Itinerary.AllBagsOrNone = trip.FlightsRequest.SelectedFlight.AllBagsOrNone;
                        flight.Details.Itinerary.PriorityForPreSelection = trip.FlightsRequest.SelectedFlight.PriorityForPreSelection;

                        //flight.Details.Itinerary.PriorityForPreSelection = false;
                        if (flight.Details.Itinerary.LeadBaggagePrice === 0 || (flight.Details.AllBagsOrNone && cm.bags > 0)) {
                            numBags = cm.nonInfantPassengers;
                        }

                        flight.Details.Itinerary.bags = numBags;
                        // This is a terrible hack to make the select flight work with the razor partial

                        cm.currentFlight = [flight.Details.Itinerary];
                        cm.currentFlightRequestedDates = _matchesRequestedDates(flight.Details.Itinerary, departureDate, returnDate);
                    }

                    return flightSearch.getSearchResults(
                        searchId,
                        $routeParams.tripId,
                        _.get(trip, 'FlightsRequest.SelectedFlight.FlightId')
                    );
                }, () => flightSearch.getSearchResults(searchId, $routeParams.tripId))
                .then(_setResults);

            $scope.$watch('cm.bags', (newval, oldval) => {
                if (newval !== oldval) {
                    const flight = cm.currentFlight && cm.currentFlight[0];
                    if (flight) {
                        broker.publish('searchCriteriaModified');
                        const opts = {
                            bags: cm.bags,
                            maxbags: cm.nonInfantPassengers
                        };
                        basketService.updateFlight(flight, $routeParams.tripId, opts, newval);
                    } else {
                        flightSearch.modifyBags(newval);
                    }
                }
            });
        });

    function selectFlight(f) {
        if (TRPCONFIG.Domain2.ShowChangeNightsPopupWhenSelectFlight) {
            const curFlight = cm.currentFlight && cm.currentFlight[0];
            const [checkInCur, checkOutCur] = basketService.getHotelDatesFromFlight(curFlight);
            const [checkInNew, checkOutNew] = basketService.getHotelDatesFromFlight(f);
            const nights = basketService.getNumberOfNightsFromFlights(f, curFlight);
            if (!checkInCur || !checkInNew || !checkOutCur || !checkOutNew) {
                return proceedFlightSelection(f);
            }
            if (checkInCur !== checkInNew || checkOutCur !== checkOutNew) {
                return showChangeNightsConfirmationPopup([checkInNew, checkOutNew, checkInCur, checkOutCur], nights)
                    .then(() => {
                        _block();
                        proceedFlightSelection(f);
                    });
            }
            _block();
        }
        return proceedFlightSelection(f);
    }

    function showChangeNightsConfirmationPopup(dates, [selectedFlightNights, curFlightNights]) {
        const headerText = resourceService.get('CHANGENIGHTSPOPUPHEADER');
        const fromText = resourceService.get('UNIVERSALFROMLABEL');
        const toText = resourceService.get('UNIVERSALTOLABEL');
        const messageText = resourceService.get('CHANGENIGHTSPOPUPMESSAGE');
        const nightsText = resourceService.get('UNIVERSALNIGHTSLABEL');
        const okButtonLabel = resourceService.get('CHANGENIGHTSPOPUPOK');
        const cancelButtonLabel = resourceService.get('CHANGENIGHTSPOPUPCANCEL');
        const [checkInNew, checkOutNew, checkInOld, checkOutOld] = dates.map(d => {
            return $filter('date')(d, 'EEE d MMM yyyy');
        });
        const dateTemplate = `
            <br>
            <br>${fromText} <b>${checkInOld} - ${checkOutOld}</b> (<b>${curFlightNights}</b> ${nightsText}</b>)
            <br>${toText} <b>${checkInNew} - ${checkOutNew}</b> (<b>${selectedFlightNights}</b> ${nightsText})
            `;
        let messageHtml = messageText + dateTemplate;
        return confirmPopupService.showPopup({
            popupHeader: headerText,
            popupMessage: messageHtml,
            okButtonLabel,
            cancelButtonLabel
        });
    }


    function proceedFlightSelection(f) {
        try {
            analytics.track('Event', 'SelectFlight', {
                Revenue: f.LeadAdultPrice,
                DepartureAirport: f.Legs[0].DepartureAirport.Code,
                DestinationAirport: f.Legs[0].ArrivalAirport.Code,
                StartDate: f.Legs[0].DepartureDate,
                EndDate: f.Legs[f.Legs.length - 1].ArrivalDate
            });
        } catch (err) {}
        flightSearch.trackFlightClick(f, $routeParams.tripId);
        cm.flightUnavailable = false;
        cm.selectedFlight = f.FlightId;
        const opts = {
            bags: cm.bags,
            maxbags: cm.nonInfantPassengers
        };
        basketService.selectFlight(f, $routeParams.tripId, opts, $routeParams, queryParams);
    }

    function showDetails(flight) {
        broker.publish('showModalFlightDetails', { flight });
    }

    function showSpinner(flight) {
        return cm.selectedFlight === flight.FlightId;
    }

    function more() {
        if (searching) { return 0; }
        const moreR = cm.requestedFilteredAgg.FilteredNumberOfFlights - (cm.combinedFlights.length + 1);
        return moreR > flightSearch.pageSize() ? flightSearch.pageSize() : moreR;
    }

    function setTab(tab) {
        if (cm.tab !== tab) {
            cm.tab = tab;
        }
    }

    function listTab() {
        cm.setTab('list');
    }

    function filterTab() {
        if (cm.combinedFlights.length > 0 || cm.anyFilter) {
            cm.setTab('filter');

            //hack to make sure that the range sliders get re-initialised
            $timeout(function() {
                $scope.$broadcast('expanderExpanded');
            }, 0);
        }
    }

    function translateStop(stop) {
        stop = parseInt(stop);
        return stop === 0 ? resourceService.get('DIRECTFLIGHT') :
            stop === 1 ? resourceService.get('ONESTOP') :
            stop === 2 ? resourceService.get('TWOPLUSSTOPS') : '';
    }

    function sortTab() {
        if (cm.combinedFlights.length > 0 || cm.anyFilter) {
            cm.req = flightSearch.getAvailabilityRequest();
            cm.setTab('sort');
        }
    }

    function _block() {
        const isHoliday = $route.current && $route.current.area === 'holidays';
        $scope.$emit('block', {
            title: resourceService.get(isHoliday ? 'SEARCHINGFLIGHTSANDHOTELS' : 'SEARCHINGFLIGHTS'),
            subtitle: resourceService.get('THISMAYTAKE'),
            loadingScreenStyle: isHoliday ? 'holiday-holidaySearchCtrl-isHolidayTrue' : 'flights-holidaySearchCtrl-isHolidayFalse'
        });
    }

    function _unblock() {
        broker.publish('unblock');
        $scope.$emit('unblock');
    }

    function _matchesRequestedDates(f, departureDate, returnDate) {
        return dateUtil.sameDay(f.Legs[0].DepartureDate, departureDate) && (f.Legs.length > 1 ?
            dateUtil.sameDay(f.Legs[f.Legs.length - 1].DepartureDate, returnDate) : true);
    }

    function _bindFilterData() {
        cm.filter = flightSearch.getFilter();
        cm.airportFilterSet = flightSearch.filterSet('DepartureAirport');
        cm.airlineFilterSet = flightSearch.filterSet('Airline');
        cm.departureDatesFilterSet = flightSearch.filterSet('DepartureDates') && !cm.isHotelFirstJourney;
        cm.stopFilterSet = flightSearch.filterSet('Stop');

        cm.anyFilter = false;
        angular.forEach(rangeFilters, function(filter) {
            cm[`Min${filter}Set`] = flightSearch.rangeFilterSet(filter, 'Min');
            cm[`Max${filter}Set`] = flightSearch.rangeFilterSet(filter, 'Max');

            cm.anyFilter = cm.anyFilter || cm[`Min${filter}Set`] || cm[`Max${filter}Set`];
        });
        cm.anyFilter = cm.anyFilter || cm.airportFilterSet || cm.airlineFilterSet || cm.departureDatesFilterSet || cm.stopFilterSet;
    }

    function _setResults(data) {
        bd4travel.trackFlightsResults($routeParams.tripId);
        setTimeout(() => {
            let flights = data.CombinedDates.AvailableFlights;
            analytics.track('mixpanel', 'FlightListing', {
                RepeatHotelOffered: _.some(_.get(data, 'CombinedDates.AvailableFlights'), f => f.RecentlyViewedIndex === 1),
                CarrierArray: _.map(flights, f => _.get(f, 'Legs[0].Segments[0].CarrierName')),
                ppPriceArray: _.map(flights, f => _.get(f, 'AdultFare.Amount')),
                // Will be tricky,  Prices are always per person:
                //TotalPriceArray: _.map(flights, f => f.AdultFare.Amount),
                CabinArray: _.map(flights, f => _.get(f, 'Legs[0].Segments[0].CabinType')),
                SearchID: $routeParams.tripId
            });
        });
        cm.sortCriteria = flightSearch.getSortCriteria(searchUnitService.isOneWayFlightEnabled());
        updateOccupancy();
        flightSearch.getSearchSummary(cm.tripType, $routeParams.tripId).then(searchSummary => cm.searchSummary = searchSummary);
        if (!routeSummaryUpToDate) {
            flightSearch.getRouteSummary(cm.tripType, $routeParams.tripId).then(routeSummary => cm.routeSummary = routeSummary);
            routeSummaryUpToDate = true;
        }

        tripService.getDurationSummary(searchUnitService.flight, $routeParams.tripId).then(ds => cm.durationSummary = ds);

        tripService.getFlightsRequestDepartureDate($routeParams.tripId).then(date => cm.flightDepartureDate = dateUtil.format(date, 'yyyy-MM-dd'));

        cm.filter = flightSearch.getFilter();
        cm.searchId = data.AvailabilitySearchId;
        cm.combinedFlights = data.CombinedDates.AvailableFlights;
        if (cm.isHotelFirstJourney) {
            _calculatePrices(cm.combinedFlights);
        }
        cm.requestedFilteredAgg = data.CombinedDates.FilteredAggregates;

        flightSearch.getSortCriterionDescription().then(function(so) {
            cm.sortedBy = so;
        });
        cm.agg = data.CombinedDates.UnfilteredAggregates;
        flightsFilterService.arrayifyAggregates(cm.agg, ['FlightsByAirline', 'DepartureDates']);
        flightsFilterService.populateMinimumPrice(cm.agg);
        cm.filteredAgg = data.CombinedDates.FilteredAggregates;
        cm.oneWayOnly = searchUnitService.isOneWayFlightEnabled();
        cm.showSearchUnit = TRPCONFIG.Domain.SearchUnitExpanded && TRPCONFIG.DeviceCategory !== 'Phone' ? true : !cm.agg.TotalNumberOfFlights;
        cm.busy = searching = false;

        broker.publish('flightsListUpdated', data);
        _unblock();
        _bindFilterData();
    }

    function _calculatePrices(flightList) {
        tripService.getTrip(tripId).then(trip => {
            basketStore.flightCost(trip.BasketId).then(function(cost) {
                const numPassengers = occupancyService.getNumberOfNonInfantPassengers() || 1;
                basketStore.totalCost(trip.BasketId).then(res => {
                    flightList.map(function(flight) {
                        // In some cases we get +1 or -1 delta price, but actually the flight prices are the same,
                        // this is due to rounding of the number, so we need to do this check to avoid the rounding issue
                        if (trip.FlightsRequest.SelectedFlight !== null) {
                            if (trip.FlightsRequest.SelectedFlight.LeadAdultPrice + trip.FlightsRequest.SelectedFlight.LeadAdultTax === flight.LeadAdultPrice + flight.LeadAdultTax) {
                                flight.deltaPrice = 0;
                            } else {
                                flight.deltaPrice = (flight.LeadAdultPrice + flight.LeadAdultTax) * numPassengers - cost;
                            }
                            flight.totalHolidayPrice = parseFloat(res) + flight.deltaPrice;
                        }
                        return flight;
                    });
                });
            });
        });
    }

    function _modifyResults(data) {
        _setResults(data);
        cm.listTab();
        cm.updating = false;

        if (cm.showSlideFilter === true) {
            scrollTo(0, 0);
        }
    }

    function toggleSearchUnit() {
        cm.showSearchUnit = !cm.showSearchUnit;
    }

    function openSlideFilter(e) {
        e.preventDefault();
        cm.showSlideFilter = true;
    }

    $scope.$on('$destroy', function() {
        broker.unsubscribe('HolidaySearchCtrl');
    });

    function updateOccupancy() {
        cm.nonInfantPassengers = occupancyService.getNumberOfNonInfantPassengers();
        cm.hidePerAdultExplaination = _.chain(occupancyService.getOccupancy())
            .flatMap(o => o.ChildAges)
            .every(age => age < 2 || age > 16)
            .value();
    }
}
})();
